document.addEventListener("DOMContentLoaded", () => {
    const expertiseItems = Array.from(document.querySelectorAll(".expertise__item"));
    if (expertiseItems.length < 1) return;

    const initialTopOffset = 100;
    const revealHeight = 35;

    // Function to set equal heights
    const setEqualHeights = () => {
        // Reset heights to get natural heights
        expertiseItems.forEach((item) => {
            item.style.height = "auto";
        });

        // Get the maximum height
        const heights = expertiseItems.map((item) => item.offsetHeight);
        const maxHeight = Math.max(...heights);

        // Set all items to the maximum height
        expertiseItems.forEach((item) => {
            item.style.height = `${maxHeight}px`;
        });

        // Add class to indicate equal heights are applied
        const expertiseContainer = document.querySelector(".expertise");
        if (expertiseContainer) {
            expertiseContainer.classList.add("equal-heights");
        }
    };

    // Apply sticky positioning
    expertiseItems.forEach((item, index) => {
        item.style.position = "sticky";
        item.style.top = `${initialTopOffset + index * revealHeight}px`;
        item.style.zIndex = `${index + 1}`;
    });

    // Set equal heights initially
    setEqualHeights();

    // Recalculate heights on window resize
    const handleResize = () => {
        // Debounce resize events
        clearTimeout(window.expertiseResizeTimeout);
        window.expertiseResizeTimeout = setTimeout(setEqualHeights, 150);
    };

    window.addEventListener("resize", handleResize);

    // Optional: Recalculate if fonts load after initial render
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(setEqualHeights);
    }

    if (expertiseItems.length < 2) return;
});
